import { render, staticRenderFns } from "./sifremi-unuttum.vue?vue&type=template&id=75129aa3&"
import script from "./sifremi-unuttum.vue?vue&type=script&lang=js&"
export * from "./sifremi-unuttum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports